// extracted by mini-css-extract-plugin
module.exports = {"corePrice":"az_sic","newFulfillmentCorePrice":"az_tic","coreDepositInfo":"az_uic","corePriceCompImg":"az_vic"};